import {coreApi} from "@/services/core";

export default {
  computed: {
    currentPage() {
      const page = this.$route.query.page || 1
      const currentPage = parseInt(page)
      return (currentPage)
    }
  },
  methods: {
    async dow(el){
      if (!el.Attachment){
        return;
      }else {
        const id = el.Attachment?.Id
        let response = await coreApi.get('file/download/' + id, { responseType: 'blob' })
        let blob = new Blob([response.data], { type: 'application/octet-stream' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = el.Attachment?.Name
        link.click()
        this.regular()
      }
    },
    showNotification(message, type = 'default') {
      console.log(message)
      const notifiactionTitles = {
        default: 'Информация',
        error: 'Ошибка',
        warn: 'Предупреждение',
        success: 'Успешно'
      }
      this.$notify({
        type: type,
        title: notifiactionTitles[type],
        text: message
      })
    },
    async showMePdfModal(path, id, { width, height }) {
      const res = await coreApi.get('waybill/print/5fc8aa65493e9116ed39f247',
        { responseType: 'blob' }
      )
      const URI = window.URL.createObjectURL

      document.querySelector('embed').src = URI(res.data)
    },
    async showMePdf(path, id) {
      const res = await coreApi.get(`${path}/${id}`,
        { responseType: 'blob' }
      )
      const URI = window.URL.createObjectURL
      window.open(URI(res.data))
    },
    /**
     * @param {Router} item
     */
    routeActivator(item) {
      return this.$route.name === item.name ? 'active' : ''
    },
    /**
     * @param {Router} item
     */
    routePermission(item) {
      const roles = item.meta.permissions
      if (!roles) return true
      const has = roles.find(role => role === this.userRole)
      return !!has
    },
    /**
     * @param {Router} item
     */
    routeShow(item) {
      return !!item.meta.show
    },
    /**
     * @param {Router} item
     */
    routeSchema(item) {
      const show = item.meta.showChild
      const children = item.children
      const isArray = Array.isArray(children)

      if (isArray && (show === null || show === undefined || show === true)) {
        return false
      }

      if (isArray && show === false) {
        return true
      }

      return true
    },
    regular(value, fixed = 2) {
      const numb = parseFloat(value)
      if (isNaN(numb)) return '0,00'
      return numb.toFixed(fixed)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
        .replace('.', ',')
    }

    }

}
